import React from 'react';
import PageWrapper from '../PageWrapper/PageWrapper';
import OrganizerHeader from './OrganizerHeader';
import './OrganizerDashboard.css';

const OrganizerLayout = ({ children, activeNav = 'home' }) => (
  <PageWrapper useOrganizerFooter hideHeader>
    <div className={`org-dashboard org-dashboard--nav-${activeNav}`}>
      <div className="org-dashboard-bg" aria-hidden="true" />
      <OrganizerHeader />
      <main className="org-dashboard-main">{children}</main>
    </div>
  </PageWrapper>
);

export default OrganizerLayout;
